var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "alert-large alert-large-info" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "alert-content" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-lg btn-success btn-job-complete",
              on: { click: _vm.handleMarkBookingCompleteCallback },
            },
            [
              _c("i", { staticClass: "fa fa-check" }),
              _vm._v(" Mark As Complete\n        "),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "fa fa-calendar" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-6" }, [
      _c("p", { staticClass: "lead m-b-none" }, [
        _vm._v("Admin Mark As Complete"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "no-margin" }, [
        _vm._v(
          "\n          This will mark the booking as complete. Essentially closing the booking.\n        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }